module.exports = __webpack_public_path__ + "static/img/national-Day-activities.0b5e9120.png";